import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface CabinetsCountertopsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const CabinetsCountertops: React.FC<CabinetsCountertopsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [cabinetsCountertops, set_cabinetsCountertops] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Cabinets, Countertops'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Cabinets, Countertops': v } } })
    );
    const label = 'Cabinets, Countertops';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(cabinetsCountertops)}
                />
            ) : (
                <MoneyBox
                    id={'cabinetsCountertops'}
                    allowNegative={false}
                    value={cabinetsCountertops}
                    onChange={(value) => set_cabinetsCountertops(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
